import { WarehouseTypes } from '@@/warehouses/ts';

// TODO: избавиться от этой константы
export const WAREHOUSE_TYPES = {
  sleeve: WarehouseTypes.Sleeve,
  stationary: WarehouseTypes.Stationary,
};
